module.exports = __webpack_public_path__ + "img/American_Credit_Business_Loans_Transparency.1321d8d.png";